import { XCircle } from "lucide-react";
import React, { useRef, useState } from "react";
import CustomerTable from "../../Components/Customer/CustomerTable";
import CustomButton from "../../Components/Ui/CustomButton";
import TextInput from "../../Components/Ui/TextInput";
import { Customer } from "../../Store/interfaces";
import { useScheinContext } from "../../Store/schein-context";
import { getCustomer } from "../../Utils/api";

const KundenSuche: React.FC<{
  onButtonClick: any;
}> = (props) => {
  const [searchedCustomers, setSearchedCustomers] = useState<Customer[]>([]);
  const { setSelectedCustomer, setZielOrt } = useScheinContext();
  const [userInput, setUserInput] = useState({ kundennummer: "" });
  const [isSelectedCustomer, setIsSelectedCustomer] = useState(false);

  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const getCustomers = async () => {
    try {
      if (isSending) return;

      setIsSending(true);

      try {
        const data: Customer[] = await getCustomer(userInput.kundennummer);
        setSearchedCustomers(data);
      } catch (err: any) {
        console.log("error", err);
      }

      if (isMounted.current) {
        setIsSending(false);
      }
    } catch (error) {
      alert(error);
    }
    setIsSending(false);
  };

  const customerChangeHandler = (newValue: string, inputName: string) => {
    setUserInput((prevFormData) => ({
      ...prevFormData,
      [inputName]: newValue,
    }));
  };

  const resetHandler = () => {
    setSearchedCustomers([]);
    setUserInput({ kundennummer: "" });
    setIsSending(false);
    setIsSelectedCustomer(false);
  };

  const handleRowSelection = async (
    rowData: Customer,
    _isSelected: boolean
  ) => {
    setSelectedCustomer(rowData);
    setIsSelectedCustomer(_isSelected);
    setZielOrt(`${rowData.Straße}, ${rowData.plz}, ${rowData.Ort}`);
  };

  return (
    <main className="flex flex-col items-center justify-center p-4">
      <h2 className="text-blue_royal text-lg sm:text-xl md:text-2xl font-bold text-center mb-5">
        Kundensuche
      </h2>
      <form
        className="w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl"
        onSubmit={(e) => {
          e.preventDefault();
          getCustomers();
        }}
      >
        <fieldset className="w-full flex flex-col items-center">
          <div className="flex flex-col sm:flex-row items-center justify-center w-full mb-4 gap-3">
            <TextInput
              name="kundennummer"
              placeholder="Kundennummer"
              value={userInput.kundennummer}
              onChange={customerChangeHandler}
              className="w-full sm:w-64 p-2"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  getCustomers();
                }
              }}
            />
            {userInput.kundennummer.length > 0 && (
              <button
                className="p-2 bg-gray-200 rounded-full"
                onClick={(event) => {
                  event.preventDefault();
                  resetHandler();
                }}
              >
                <XCircle size={20} />
              </button>
            )}
          </div>
          <CustomButton
            onClick={getCustomers}
            theme="navy"
            type="submit"
            className="w-full sm:w-auto px-4 py-2"
          >
            Suchen
          </CustomButton>
        </fieldset>
      </form>

      <div className="w-full max-w-[85%] mt-6">
        <CustomerTable
          customers={searchedCustomers}
          onRowSelect={handleRowSelection}
        />
      </div>

      {isSelectedCustomer && (
        <div className="w-full max-w-6xl mt-5 flex justify-center">
          <input
            className="w-full sm:w-1/2 bg-blue_navy text-white font-bold py-2 rounded hover:bg-blue-700 cursor-pointer"
            type="submit"
            value="Weiter"
            onClick={() => props.onButtonClick("info")}
          />
        </div>
      )}
    </main>
  );
};

export default KundenSuche;
